module.exports = __webpack_public_path__ + "img/access-remove.bc1b32eb.png";